import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/components/glx/scroll-to-top/箭头上.png")